import type { BenefitSummary } from "@yutai/shared"
import { formatRecordBuyDeadline, recordDeadlineThisMonth } from "../lib/nextRecordDate.js"
import styles from "./RecordDeadlineRibbon.module.css"

interface Props {
  benefit: BenefitSummary
}

export function RecordDeadlineRibbon({ benefit }: Props) {
  const buyDeadline = recordDeadlineThisMonth(benefit.recordMonths)
  if (!buyDeadline) return null

  return (
    <span
      className={styles.ribbon}
      title={`権利確定日 ${buyDeadline.recordDate.getMonth() + 1}/${buyDeadline.recordDate.getDate()}（月末を想定した概算）の2営業日前が買付期限の目安です。土日のみを考慮した概算のため、祝日を挟む場合は実際の期限より遅く出ることがあります`}
    >
      {formatRecordBuyDeadline(buyDeadline)}
    </span>
  )
}
